<template>
  <div class="navbar">
    <div class="left-menu">
      <!-- <hamburger
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSidebar"
      /> -->
      <hamburger
        id="hamburger-container"
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar"
      />

      <breadcrumb class="breadcrumb-container" />
    </div>

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar" /> -->
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-drop">
          <el-dropdown-item @click.native="handleModify">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block">登出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="修改密码" :visible.sync="modifyFormVisible">
      <el-form ref="modifyForm" :model="modifyForm" :rules="modifyFormRules">
        <el-form-item
          label="原密码"
          prop="originalpwd"
          required
          autocomplete="false"
        >
          <el-input v-model="modifyForm.originalpwd" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpwd">
          <el-input v-model="modifyForm.newpwd" show-password></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="modifyFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="modifyLoading" @click="modifySubmit"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { modify, logout } from "@/api/user.js";
import Hamburger from "@/components/Hamburger";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Hamburger,
    Breadcrumb
  },
  computed: {
    ...mapGetters(["sidebar"])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },

    logout() {
      logout().then(
        this.$message({
          message: "登出成功",
          type: "success"
        }),
        sessionStorage.removeItem("hasLogin"),
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      );
    },
    handleModify() {
      this.modifyFormVisible = true;
      this.modifyForm = {
        username: sessionStorage.getItem("username"),
        originalpwd: "",
        newpwd: ""
      };
    },
    modifySubmit() {
      this.$refs.modifyForm.validate(valid => {
        if (valid) {
          this.$confirm("确认要提交吗？").then(() => {
            modify(this.modifyForm).then(() => {
              this.$message({
                message: "修改成功",
                type: "success"
              });
            });
            this.modifyFormVisible = false;
            sessionStorage.removeItem("hasLogin");
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          });
        }
      });
    }
  },
  data() {
    const validatePwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      sidebarStatus: "",
      modifyFormVisible: false,
      modifyLoading: false,
      modifyFormRules: {
        originalpwd: [
          { required: true, trigger: "blur", validator: validatePwd }
        ],
        newpwd: [{ required: true, trigger: "blur", validator: validatePwd }]
      },
      modifyForm: []
    };
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    margin-right: 20px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    // .avatar-container {
    //   margin-right: 30px;

    //   .avatar-wrapper {
    //     margin-top: 5px;
    //     position: relative;

    //     .user-avatar {
    //       cursor: pointer;
    //       width: 40px;
    //       height: 40px;
    //       border-radius: 10px;
    //     }

    //     .el-icon-caret-bottom {
    //       cursor: pointer;
    //       position: absolute;
    //       right: -20px;
    //       top: 25px;
    //       font-size: 12px;
    //     }
    //   }
    // }
  }
}
</style>
